var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[_c('img',{attrs:{"src":_vm.statusIcon[_vm.status],"height":"12"}}),_vm._v("\n          "+_vm._s(_vm._f("taskStatusCn")(_vm.status))+"\n")])}
var staticRenderFns = []

export { render, staticRenderFns }